import { CsvProduct } from '@pages/Products/ProductCsvReader/ProductCsvReader';

const testCsvData = (data: CsvProduct[]) => {
  return;
};

const testOnClickCheckBox = (header: string) => {
  return header;
};

const testUnSelectAll = (data: string[]) => {
  return data;
};

const testSelectAll = (headers: string[]) => {
  return headers;
};

export const TestCsvData = {
  testCsvData,
  testUnSelectAll,
  testSelectAll,
  testOnClickCheckBox,
};
